import { render, staticRenderFns } from "./RegisterConfirmation.vue?vue&type=template&id=13c1d305&scoped=true"
import script from "./RegisterConfirmation.vue?vue&type=script&lang=js"
export * from "./RegisterConfirmation.vue?vue&type=script&lang=js"
import style0 from "./RegisterConfirmation.vue?vue&type=style&index=0&id=13c1d305&prod&lang=scss&scoped=true"
import style1 from "./RegisterConfirmation.vue?vue&type=style&index=1&id=13c1d305&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1d305",
  null
  
)

export default component.exports